// BaseLRUStore.ts
import {LRUCache} from 'lru-cache';

export abstract class BaseLRUStore<K = string, V = unknown> {
  protected cache: LRUCache<K, V>;

  constructor(maxSize: number = 100) {
    this.cache = new LRUCache<K, V>({
      max: maxSize,
      dispose: (value, key) =>
        queueMicrotask(() => {
          this.onEvict(key, value);
        })
    });
  }

  get(key: K): V | undefined {
    return this.cache.get(key);
  }

  set(key: K, value: V): void {
    this.cache.set(key, value);
  }

  delete(key: K): void {
    this.cache.delete(key);
  }

  has(key: K): boolean {
    return this.cache.has(key);
  }

  clear(): void {
    this.cache.clear();
  }
  
  size(): number {
    return this.cache.size;
  }
  /**
   * workAround to protect keys from eviction.
   * @param key
   */
  touchBulk(key: K[]): void {
    key.forEach(k => this.cache.get(k));
  }

  /**
   * workAround to protect keys from eviction.
   * @param key
  */
  touch(key: K): void {
    this.cache.get(key);
  }
  
  maxAllowedSize(): number {
    return this.cache.max;
  }

  protected onEvict(key: K, value: V): void {
    // extended classes can implement this method to handle eviction logic
  }
}
